var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAverageBooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.1797V9.17969C22.5 4.17969 20.5 2.17969 15.5 2.17969H9.5C4.5 2.17969 2.5 4.17969 2.5 9.17969V15.1797C2.5 20.1797 4.5 22.1797 9.5 22.1797H13.5",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82812 14.6695L10.2081 11.5794C10.5481 11.1394 11.1781 11.0594 11.6181 11.3994L13.4482 12.8395C13.8882 13.1795 14.5181 13.0995 14.8581 12.6695L17.1682 9.68945",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9812 15.9991L20.2612 16.5691C20.4012 16.8491 20.7512 17.1091 21.0612 17.1691L21.4412 17.2291C22.5812 17.4191 22.8512 18.2591 22.0312 19.0891L21.6812 19.4391C21.4512 19.6791 21.3212 20.1391 21.3912 20.4591L21.4412 20.6691C21.7512 22.0491 21.0212 22.5791 19.8212 21.8591L19.5612 21.7091C19.2512 21.5291 18.7512 21.5291 18.4412 21.7091L18.1812 21.8591C16.9712 22.5891 16.2412 22.0491 16.5612 20.6691L16.6112 20.4591C16.6812 20.1391 16.5512 19.6791 16.3212 19.4391L15.9712 19.0891C15.1512 18.2591 15.4212 17.4191 16.5612 17.2291L16.9412 17.1691C17.2412 17.1191 17.6012 16.8491 17.7412 16.5691L18.0212 15.9991C18.5612 14.9091 19.4412 14.9091 19.9812 15.9991Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageBooking);
export default __webpack_public_path__ + "static/media/averageBooking.e4c26974724fd039f5784167f339ffa8.svg";
export { ForwardRef as ReactComponent };